<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>Verificador On-Line Gratuito de Pontuação</h1></div>
                    <p>Corrija instantaneamente seus erros de pontuação com o verificador gratuito do Trinka, movido a inteligência artificial.<br/>O Trinka AI ajuda você a escrever documentos com confiança, encontrando e corrigindo erros de pontuação para melhorar sua escrita.</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>



<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <div class="col-sm-12 col-md-8 col-lg-9">
                    <h2>Verificações de gramática e pontuação para uma escrita perfeita em qualquer lugar!</h2>
                </div>
                <div class="col-sm-4 col-md-4 col-lg-3 text-center">
                    <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">Instalar en Chrome</a>
                    <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai/" target="_blank"><img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">También disponible en Firefox</a>
                    <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">Instalar en Edge</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>Sua conta gratuita no Trinka</h2>
                    <P>Verifique até 10.000 palavras da sua escrita todo mês e note uma melhoria geral na sua linguagem e estilo.</P>
                    <a href="https://cloud.trinka.ai/signup?_rg=GB" target="_blank">Inscreva-se JÁ!</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="trinka_demo_wrap" style="display: none !important;">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h3>Verificador On-Line Gratuito de Pontuação</h3>
                        <div class="HeadingSubLine"></div>
                        <p>Corrija instantaneamente seus erros de pontuação com o verificador gratuito do Trinka, movido a inteligência artificial.<br/>O Trinka AI ajuda você a escrever documentos com confiança, encontrando e corrigindo erros de pontuação para melhorar sua escrita.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="editor_sections" style="height:100%;">
                        <div class="gcLoaderSection" *ngIf="showloader">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                </circle>
                            </svg>
                        </div>
                        <div style="display: none;" class="loading loader" #loading>&#8230;</div>
                        <div class="editor_top_section" [ngClass] = "(wordCount > maxLength) ? 'redWord' : '' ">
                            <!-- <span (click)="addDummyText()" class="dummy-text">Example text</span> -->
                            <span class="dorpdownText">
                                <button mat-button [matMenuTriggerFor]="sample" class="tryDemo_exampleText file_manager_dropdown">
                                    <!-- <img class="img-fluid" src="../../../../assets/images/UseExampleText.svg" alt="logo favicon"> -->
                                    <span>Exemplo de Texto<i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </button>
                                <mat-menu #sample="matMenu" class="file_manager_sub_menus new_file_sections">
                                    <mat-radio-group aria-label="Select an option" (change)="addSampleData($event)" name="example">
                                        <ng-container *ngFor="let data of sampleData;index as i;">
                                            <mat-radio-button value="{{data.key}}">{{data.key}} </mat-radio-button><br>
                                        </ng-container>
                                    </mat-radio-group>
                                </mat-menu>
                            </span>
                            <span class="float-right word_count_section">Palavras: <b>{{wordCount}}/{{maxLength}}</b></span>
                        </div>

                        <!-- <div class="ck-editor" z>
                            <ck-editor name="editor1" [(ngModel)]="editorValue" [config]="config" language="en"
                                [fullPage]="false" (change)="onChange($event)" (blur)="onBlur($event)"
                                (focus)="onFocus($event)" (focusout)="outFocus($event)" (mouseup)="onMouseUp($event)"
                                (paste)="onPaste($event)" (keyup)="onKeyUp($event)" placeholder="Write your message">
                            </ck-editor>
                        </div> -->
                        <div class="ck-editor" style="height:280px; overflow: auto;">
                            <textarea #sampleEditor id ="sampleEditor" style="height: 100%;width: 100%;border: none;padding: 10px;outline: 0;display: block ;" (keyup)="onChange($event)" (paste)="onChange($event)" (change)="onChange($event)"></textarea>
                        </div>
                        <div class="Footer_button_section">
                            <div class="footer_radionButtons">
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation2"
                                        [checked]="languageSelection == 'us'" name="radio-stacked" value="us"
                                        name="style" (change)="languageTypeSelect('us')" required>
                                    <label class="custom-control-label mr-3"
                                        for="customControlValidation2">English-US</label>
                                </div>
                                <div class="custom-control custom-radio d-inline">
                                    <input type="radio" class="custom-control-input" id="customControlValidation3"
                                        [checked]="languageSelection == 'uk'" name="radio-stacked" value="uk"
                                        name="style" (change)="languageTypeSelect('uk')" required>
                                    <label class="custom-control-label"
                                        for="customControlValidation3">English-UK</label>
                                </div>
                            </div>
                            <div class="check_emailBox">
                                <!-- <input type="text" class="form-control" id="text-email" placeholder="Enter your email"
                                    [(ngModel)]="emailAdress"> -->
                                <button id="checkMyWritingButton" (click)="onGrammarCheck($event)" [disabled]="enableCheck || isProcessStarted"
                                    class="btn btn-primary">Verifique minha escrita
                                    <div class="gcLoaderSection" *ngIf="isProcessStarted">
                                        <svg style="margin: auto; display: block;" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; display: inline-block;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                            <circle cx="75" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.9166666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.9166666666666666s"></animate>
                                            </circle><circle cx="71.65063509461098" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.8333333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.8333333333333334s"></animate>
                                            </circle><circle cx="62.5" cy="71.65063509461096" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.75s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.75s"></animate>
                                            </circle><circle cx="50" cy="75" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.6666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.6666666666666666s"></animate>
                                            </circle><circle cx="37.50000000000001" cy="71.65063509461098" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5833333333333334s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5833333333333334s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="62.5" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.5s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.5s"></animate>
                                            </circle><circle cx="25" cy="50" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.4166666666666667s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.4166666666666667s"></animate>
                                            </circle><circle cx="28.34936490538903" cy="37.50000000000001" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.3333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.3333333333333333s"></animate>
                                            </circle><circle cx="37.499999999999986" cy="28.349364905389038" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.25s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.25s"></animate>
                                            </circle><circle cx="49.99999999999999" cy="25" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.16666666666666666s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.16666666666666666s"></animate>
                                            </circle><circle cx="62.5" cy="28.349364905389034" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="-0.08333333333333333s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="-0.08333333333333333s"></animate>
                                            </circle><circle cx="71.65063509461096" cy="37.499999999999986" fill="#fff9f5" r="5">
                                            <animate attributeName="r" values="3;3;5;3;3" times="0;0.1;0.2;0.3;1" dur="1s" repeatCount="indefinite" begin="0s"></animate>
                                            <animate attributeName="fill" values="#fff9f5;#fff9f5;#763393;#fff9f5;#fff9f5" repeatCount="indefinite" times="0;0.1;0.2;0.3;1" dur="1s" begin="0s"></animate>
                                            </circle>
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- <p class="myWriting_text">By clicking Check My Writing, you are agreeing to our <a
                            routerLink="/termsofservices/">Terms of Service</a> and <a
                            routerLink="/privacypolicy/">Privacy Policy</a>.</p> -->
                              
                </div>
                <div class="col-lg-4">
                    <div class="gcResultSection">
                        <div class="trinkaPluginGCSection">
                            <h2>Sua conta gratuita no Trinka</h2>
                            <P>Verifique até 10.000 palavras da sua escrita todo mês e note uma melhoria geral na sua linguagem e estilo.</P>
                            <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Inscreva-se JÁ!</a>
                            <h3>Recursos especiais:</h3>
                            <ul>
                                <li>Erros de gramática e ortografia</li>
                                <li>Escolha de palavras</li>
                                <li>Melhoria da linguagem</li>
                                <li>Conselhos de escrita</li>
                            </ul>
                        </div>
                        <!-- <div class="editor_options_with_cards" *ngIf="alertErrorMessage == 'TRUE' &&!gec_result.length">
                            <h2>The issues detected in your text will be displayed here.</h2>
                            <h3>Our robust correction algorithm checks your English text for</h3>
                            <ul>
                                <li>Grammar errors</li>
                                <li>Spelling mistakes</li>
                                <li>US–UK spellings</li>
                                <li>Word usage</li>
                                <li>Language enhancement</li>
                                <li>Writing advice</li>
                            </ul>
                        </div> -->
    
                        <h4 *ngIf="!noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
                        <h4 *ngIf="!gec_result.length && noeErrorFound && alertErrorMessage != 'TRUE'"
                            class="align-content-center again_check_my_writing tempClass" [innerHTML]="alertErrorMessage">
                        </h4>
    
                        <div *ngIf="gec_result.length" class="mt-0 font-14 issueCountLabel-wrap">
                            <span class="issueCountLabel"> Issues Found: <span class="errors-ctn">{{gec_result.length}}</span></span>
                        </div>
    
                        <div class="errorPanel" *ngIf="gec_result.length">
                            <mat-accordion>
                                <ng-container *ngFor="let item of gec_result ; let j = index">
                                    <mat-expansion-panel class="mat-expansion-panel-spacing mb-2 mt-0 error-type"
                                        *ngIf="!item.isCorrected" (opened)="setStep(item, j)" (closed)="setStepOff(item, j)"
                                        [ngClass]="injectErrorClass(item)" [expanded]="j === 0">
                                        <mat-expansion-panel-header>
                                            <mat-panel-title>
                                                <ng-container *ngIf="!item.isExpanded">
    
                                                    <div>
                                                        <strong> {{item.covered_text}}</strong>
                                                    </div>
                                                    <span *ngIf="item.error_type[0] == 1">&nbsp;(Grammar)</span>
                                                    <span *ngIf="item.error_type[0] == 2">&nbsp;(Spelling)</span>
                                                    <span *ngIf="item.error_type[0] == 3">&nbsp;(Writing
                                                        Adviser)</span>
                                                    <span *ngIf="item.error_type[0] == 4">&nbsp;(Enhancement)</span>
                                                </ng-container>
    
                                                <div *ngIf="item.isExpanded">
                                                    <strong *ngIf="item.error_type[0] == 1">&nbsp;
                                                        Grammar</strong>
                                                    <strong *ngIf="item.error_type[0] == 2">&nbsp;
                                                        Spelling</strong>
                                                    <strong *ngIf="item.error_type[0] == 3">&nbsp; Writing
                                                        Adviser</strong>
                                                    <strong *ngIf="item.error_type[0] == 4">&nbsp;
                                                        Enhancement</strong>
                                                </div>
                                            </mat-panel-title>
                                            <mat-panel-description>
                                                <span (click)="rejectChange(item,j,false)">
                                                    <img src="assets/images/delete-icon.png" alt="delete icon">
                                                </span>
    
                                            </mat-panel-description>
                                        </mat-expansion-panel-header>
                                        <div *ngFor="let output of item.output; let k = index" class="error-main">
                                            <div class="error-inner">
                                                <div
                                                    *ngIf="(item.output[k] == '' && item.error_type[k] == 3 || item.error_type[k] == 4) && !item.cta_present[k]">
                                                    <label> {{item.covered_text}}</label>
                                                </div>
                                                <div *ngIf="item.output[k] != '' && item.cta_present[k]">
                                                    <b><s>{{item.covered_text}}</s></b> <span class="arrow"><img
                                                            src="assets/images/arrow.png" alt="arrow"></span>
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">{{item.output[k]}}</label>
                                                </div>
    
                                                <div *ngIf="item.output[k] == '' && item.cta_present[k]">
                                                    <label class="error-link" (click)="error_panel_action(item,j,output)"
                                                        [ngClass]="injectErrorClass(item)">Delete
                                                        '<span>{{item.covered_text}}</span>'</label>
                                                </div>
                                            </div>
                                            <div class="error-comment">{{item.comment[k]}}</div>
                                            <hr>
                                        </div>
                                    </mat-expansion-panel>
                                </ng-container>
                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- 
<div class="trinka_demo_wrap gcBannerSection">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h1>Verificador On-Line Gratuito de Pontuação</h1>
                        <div class="HeadingSubLine"></div>
                        <p>Corrija instantaneamente seus erros de pontuação com o verificador gratuito do Trinka, movido a inteligência artificial.<br/>O Trinka AI ajuda você a escrever documentos com confiança, encontrando e corrigindo erros de pontuação para melhorar sua escrita.</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-7 col-md-9 col-sm-12 col-12">
                    <div class="gcResultSection">
                        <div class="trinkaPluginGCSection">
                            <p>Estamos atualizando a nossa ferramenta Free Grammar Checker (Verificador Gramatical Gratuito), motivo pelo qual ela não está disponível no momento. Entretanto, isso não deve impedi-lo de escrever.</p>
                            <p>Inscreva-se e use o nosso editor online gratuito, que verifica a sua redação em até 10.000 palavras, todos os meses, e possui recursos especiais adicionais:</p>
                            <div class="text-center"><a href="https://cloud.trinka.ai/signup?ref=PT-Punctuation" target="_blank">Inscreva-se AGORA!</a></div>
                            <h3 class="text-center">Características especiais:</h3>
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <ul class="row">
                                        <li class="col-lg-6 col-sm-6 col-12">Erros de gramática e ortografia</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Escolha de palavras</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Aprimoramento do idioma</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Aconselhamento sobre a escrita</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Guias de estilo</li>
                                        <li class="col-lg-6 col-sm-6 col-12">Dicionário personalizado</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->


<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>O Melhor Verificador On-Line de Pontuação</h2>
                    <div class="HeadingSubLine"></div>
                    <p>O verificador de pontuação do Trinka não apenas verifica o uso correto da pontuação, mas também corrige erros complexos de gramática, estilo e tom!</p>
                    <p>O Trinka aprendeu com os artigos mais bem escritos em cada disciplina para proporcionar a você as sugestões mais relevantes. Com o Trinka, a sua escrita sempre será precisa.</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>Poupe tempo verificando sua pontuação </li>
                            <li>Desfrute da verificação gratuitamente</li>
                            <li>Profissionalize a sua escrita</li>
                            <li>Segurança de dados de alta qualidade</li>
                        </ul>
                    </div>
                    <p>A verificação on-line de pontuação do Trinka detecta erros em vírgulas, hífens, pontos e vírgulas e outros sinais de pontuação, além de dar sugestões para melhor compreensão.</p>
                    <p>Inscreva-se para liberar mais recursos gratuitamente!</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank" class="cta-btn">Começar</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2>Quem pode usar este verificador de pontuação?</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>O Trinka é ideal para qualquer um que esteja tentando melhorar suas habilidades de escrita em inglês. A ferramenta gratuita de verificação de pontuação do Trinka tem a confiança de acadêmicos, redatores, pessoal de marketing, escritores de conteúdo, equipes de produto, blogueiros, autores independentes e outros. </p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>Principais Recursos do Verificador On-Line de Pontuação do Trinka</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>Verificação perfeita da pontuação</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>O Trinka oferece verificações contextualizadas da pontuação para melhorar a sua escrita.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>In this economic recession, the Japanese economy managed to bounce back from the recession <span class="wrong_text">quickly,</span>&nbsp;<span class="right_text"> quickly</span> and achieved relatively good results.</p>
                            
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>Funciona em todas as áreas</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>O Trinka oferece-lhe as sugestões mais relevantes de pontuação, com base na sua área do conhecimento.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Syntax</h4> -->
                            <p>Therefore, it is shaped like a column if the agents have the most <span class="wrong_text">risk prone</span>&nbsp;<span class="right_text"> risk-prone</span> attitude.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>Escolha de palavras</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Além das verificações de pontuação, o Trinka corrige erros de gramática e escolha de palavras, para tornar a sua escrita correta e clara. Comunique sua intenção de forma precisa com o Trinka.</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Advance Spelling</h4> -->
                            <p>One of the reasons is <span class="wrong_text">because</span> <span
                                class="right_text"> that</span> the fabrication cost <span
                                class="wrong_text">for</span> <span class="right_text"> of</span> steel
                            members depends upon the material.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>Verificação ortográfica avançada</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Além de corrigir erros de pontuação, o verificador ortográfico gratuito do Trinka examina o contexto da sua escrita para ajudar você a escolher as palavras certas para o seu assunto. Chega de erros estranhos de ortografia!</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>Use a Trinka em outros aplicativos</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="trinka cloud">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/wordAdd_in.svg" alt="word addin">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="../../../assets/images/safari_logo.png" alt="safari logo">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row flex-row-reverse align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Como funbciona o verificador gratuito de pontuação do Trinka?</h2>
                    <p>O Trinka é um verificador de pontuação e assistente linguístico de escrita, projetado para melhorar a escrita acadêmica e técnica. </p>
                    <p>Baseado no contexto da frase, nosso verificador de pontuação, desenvolvido com as técnicas mais recentes de aprendizado de máquina e processamento de linguagem natural, identifica facilmente erros em vírgulas, hífens, apóstrofos, pontos e vírgulas e outros sinais de pontuação, sugerindo melhorias para mais clareza e legibilidade.</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/WritingMoreEffective.png" alt="effective writing">
                </div>
            </div>
            
        </div>
        <div class="row colunmChangesSection align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Aprenda o uso correto dos sinais de pontuação com o verificador de pontuação do Trinka</h2>
                    <p>Toda correção de pontuação é uma oportunidade de aprender. O verificador de pontuação do Trinka não apenas realça os erros, mas também explica como corrigi-los e dá explicações relevantes, que ajudam você a escrever melhor. Além das verificações de pontuação, o Trinka também verifica a gramática e erros de linguagem e dá uma pontuação indicativa da qualidade geral da sua escrita.</p>
                    <p>Através da verificação de pontuação do Trinka, os estudantes podem aprender como escrever de forma eficaz e inculcar as melhores práticas de escrita.</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="../../../assets/images/LearnGrammarwithTrinka.png" alt="learn grammar">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="quote icon">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="quote icon">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="../../../assets/images/quote_icons.png" alt="quote icon">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>Depoimentos</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="../../../assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/James-Smith.jfif" alt="james smith">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Primeiramente, eu amo Trinka. Parabéns por desenvolverem algo que ajuda amplamente
                                                        na edição, especialmente convenções gramaticais críticas e reduções na
                                                        contagem de palavras.
    
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">Editor Acadêmico, EUA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="Rosa-Diaz-Sandoval">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Escrever textos com gramática e estilo corretos em inglês não é uma tarefa
                                                        fácil para pessoas que falam outros idiomas. Às vezes, você não consegue
                                                        encontrar pequenos erros em seu documento sem ajuda, especialmente para
                                                        redação acadêmica. Experimentei Trinka Al como ferramenta de correção
                                                        automática e fiquei bastante satisfeita com as correções sugeridas e
                                                        o feedback. Com o feedback você entende porque a mudança sugerida deve
                                                        ser levada em consideração.</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">PhD em Física e Matemática, México</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="farooq rathore" />
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Uso trinka especialmente para melhorar a linguagem, gramática e sintaxe dos
                                                        manuscritos científicos que escrevo para periódicos biomédicos nacionais
                                                        e internacionais. Achei a interface amigável e o procedimento, em si,
                                                        é eficiente e descomplicado. As diferentes opções para para editar o
                                                        manuscrito conforme às necessidades me ajudam a decidir em qual área
                                                        devo focar. A edição automática é de grande ajuda e a página suplementar
                                                        com o resumo da revisão é uma excelente idéia. </p>
                                                    <p class="authorNameText">Dr. Farooq Rathore</p>
                                                    <span class="authorDesignationText">Professor Assistente e Chefe de Departamento, Paquistão</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Georgieva-Milena.jpg" alt="Georgieva-Milena">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka Al é a minha escolha favorita para edição gramatical e ortográfica.
                                                        A plataforma funciona corretamente, é rápida e organizada! Estou completamente
                                                        satisfeita!
                                                    </p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="dinesh gupta">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">A ferramenta de verificação gramatical supera o Grammarly! Verifiquei novamente
                                                        alguns documentos que havia verificado anteriormente com o Grammarly.
                                                        Fiquei agradavelmente surpreso ao me deparar com tal produto originário
                                                        da Índia.
                                                    </p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">Radiologista, Índia</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Edith-Davies.jpg" alt="Edith-Davies">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Testei Trinka e fiquei impressionada com suas excelentes capacidades. Trinka
                                                        é melhor do que o verificador gramatical que uso. Parabéns! Falei para
                                                        os meus colegas de laboratório de pesquisa para usarem Trinka. Espero
                                                        que Trinka seja usado amplamente no meio acadêmico.
                                                    </p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">Bolsista de Doutorado, Reino Unido</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Noor-Al-rishi.png" alt="noor-al-rishi">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">As correções e feedback sugeridos por Trinka Al me surpreenderam. É simples
                                                        de usar e extremamente benéfico.
                                                    </p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">Bolsista de Química, Arábia Saudita</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Nwaji-Jude.jpg" alt="Nwaji-Jude">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Tem sido uma experiência maravilhosa usar Trinka e quase não consigo enviar
                                                        nenhum manuscrito sem que seja verificado por ele. Em resumo, Trinka
                                                        tem sido um salva-vidas.
                                                    </p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="stumpf curtis">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Gosto de usar Trinka como verificação final para meus documentos editados.
                                                        Trinka realmente ajuda a encontrar erros remanescentes que escapam durante
                                                        a primeira verificação. Gosto muito desta plataforma. O botão do polegar
                                                        para baixo é muito útil.
    
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Dyke-Gareth.jfif" alt="dyke gareth">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Acho Trinka Al uma ideia muito interessante e potencialmente útil, especialmente
                                                        para editores/periódicos. Eu achei trinka muito útil quando verifiquei
                                                        o meu trabalho de edição na plataforma.
                                                    </p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">Pesquisador</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="bhargava sharma">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Estou feliz com o desempenho geral. Uso Grammarly faz muito tempo, mas quando
                                                        se trata de redação acadêmica ou técnica, Trinka é definitivamente uma
                                                        opção melhor. As configurações de documentos acadêmicos e a edição automática
                                                        de arquivos são os meus recursos favoritos.
                                                    </p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">Epidemiologista, Índia</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Ralph-Bailey.jfif" alt="ralph bailey">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka tornou-se minha ferramenta favorita para correções gramaticais. As
                                                        correções com inteligência artificial e os aprimoramentos de linguagem
                                                        tornaram a escrita muito mais fácil. Agora, posso me concentrar mais
                                                        na pesquisa do que em escrever um documento livre de erros.
                                                    </p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">Neurologista, EUA</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="../../../assets/images/clientPhotos/Thomas-Andres.jfif" alt="thomas andres">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">A correção gramatical e a sugestão com base no guia de estilo da AMA são
                                                        realmente impressionantes! Trinka é, de fato, a melhor ferramenta de
                                                        correção gramatical para redação médica.
    
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">Cardiologista, Brasil</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>Receba um orçamento personalizado</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank" id="grammerSignUpButton">
                        <span>Solicitar uma Demonstração</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>Perguntas Mais Frequentes sobre o Verificador de Pontuação do Trinka</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            Como funciona o verificador de pontuação do Trinka?</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>A ferramenta de verificação de pontuação do Trinka foi desenvolvida com as técnicas mais recentes de aprendizado de máquina e processamento de linguagem natural, para identificar facilmente erros de pontuação e sugerir melhorias. A inteligência artificial do Trinka garante que a sua escrita tenha pontuação consistente em termos da estrutura da frase.</p>
                                        </div>
                                    </div>
                                </div>        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">A verificação de gramática e pontuação do Trinka é gratuita?</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Sim, o Plano Básico do Trinka é completamente gratuito. Você pode <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">se inscrever</a> aqui e começar a usar a ferramenta.</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent">Quais erros de pontuação o Trinka pode verificar?</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>O Trinka pode verificar os seguintes erros de pontuação:</p>
                                            <ul>
                                                <li>Vírgula (,)</li>
                                                <li>Ponto (.)</li>
                                                <li>Hífen (-)</li>
                                                <li>Ponto e vírgula (;)</li>
                                                <li>Dois pontos (:)</li>
                                                <li>Ponto de interrogação (?)</li>
                                                <li>Travessão (—)</li>
                                                <li>Traço (–)</li>
                                                <li>Apóstrofo (‘)</li>
                                                <li>Reticências (…)</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">Posso verificar a pontuação em Web sites diferentes?</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>Sim, basta instalar nosso <a  [routerLink]="['/browser-plugin']">plug-in de navegador</a> para o Chrome, Firefox ou Edge e observar o Trinka fazer sua mágica.</p>
                                        </div>
                                    </div>
                                </div>

                                
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>




<!-- Modal -->
<div class="modal fade" id="usageLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="usageLimitExhaustedLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <button type="button" id="closedExceededPopup" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>

          <div class="upgradePremiumSection">
            <div class="upgradeHeaderSection">
               <div class="upgradeHeaderSection_overlay"></div>
               <h4>Opa! Limite de conteúdo excedido.</h4>
            </div>
            <div class="upgradeBodySection">
               <!-- <h2>Sign Up for free and get 5000 words/month</h2> -->
               <p style="margin: 0; margin-top: 10px;">Com uma conta Trinka gratuita, você pode verificar se está escrevendo até 10.000 palavras por mês. Tudo que você precisa fazer é se inscrever gratuitamente.</p>
               <!-- <p> All you need to do is Sign Up for free.</p> -->
               <div class="goupgradeButton">
                  <a href="https://cloud.trinka.ai/signup?_rg=PT" target="_blank">Cadastre-se aqui</a>
                  <button id="FooterClosedExceededPopup">Voltar para o editor</button>
               </div>
            </div>
         </div>
      </div>
    </div>
</div>
    <!--Modal for accept limit exceeded-->
<div class="modal fade" id="acceptedLimitExhausted" tabindex="-1" role="dialog" aria-labelledby="acceptedLimitExhaustedLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <button type="button" id="closedAcceptedLimitExhaustedPopup"   (click)="hideModal2()"  class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
             <div class="limitExhaustedBody">
                 <div class="limitExhaustedLeftContent">
                     <div class="logoSection">
                         <img src="../../../assets/images/trinka-logo.png" alt="trinka logo">
                     </div>
                     <div class="ExhaustedLeftContent">
                         <h2>Mais correções de gramática e edições com um clique.</h2>
                         <a href="https://cloud.trinka.ai/signup?_rg=Punctuation-Checker-JS-PT" target="_blank">Obtenha uma conta gratuita</a>
                     </div>
                 </div>
                 <div class="limitExhaustedRightContent">
                    <div class="rightInnerContent">
                        <img class="backgourndImageSection" src="../../../assets/images/home_banner.jpg" alt="gc checker">
                        <div class="imagesOverlaySection"></div>
                    </div>
                    <div class="ExhastedRightContainer">
                       <img src="../../../assets/images/GC_grammarCheckCard.png" class="grammarCheckCardImg" alt="gc card" >
                       <img src="../../../assets/images/GC_EnhanCheckCard.png" class="EnhanmentCheckCardImg" alt="gc check card" >
                        <a href="https://cloud.trinka.ai/signup?_rg=Punctuation-Checker-JS-PT" target="_blank">Obtenha uma conta gratuita</a>
                    </div>
                 </div>
             </div>
    
          </div>
        </div>
      </div>